import { render, staticRenderFns } from "./Notificacion.vue?vue&type=template&id=fc16625c&scoped=true"
import script from "./Notificacion.vue?vue&type=script&lang=js"
export * from "./Notificacion.vue?vue&type=script&lang=js"
import style0 from "./Notificacion.vue?vue&type=style&index=0&id=fc16625c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc16625c",
  null
  
)

export default component.exports